window.PhoneModels = {
  "iphone-13": {
    label: "iPhone 13",
    frameRatio: 0.49,
    shellRadius: 26,
    safeZone: { top: 10.5, left: 10, width: 80, height: 84 },
    camera: { style: "dual", top: 4.6, left: 7.2, width: 23, height: 18.5, radius: 28 }
  },
  "iphone-13-mini": {
    label: "iPhone 13 Mini",
    frameRatio: 0.5,
    shellRadius: 24,
    safeZone: { top: 10.2, left: 10.5, width: 79, height: 84.5 },
    camera: { style: "dual", top: 4.8, left: 7.5, width: 22, height: 18, radius: 26 }
  },
  "iphone-13-pro": {
    label: "iPhone 13 Pro",
    frameRatio: 0.49,
    shellRadius: 27,
    safeZone: { top: 10.5, left: 9.8, width: 80.2, height: 83.8 },
    camera: { style: "pro", top: 4.2, left: 6.8, width: 26.5, height: 21.5, radius: 30 }
  },
  "iphone-13-pro-max": {
    label: "iPhone 13 Pro Max",
    frameRatio: 0.476,
    shellRadius: 28,
    safeZone: { top: 10.2, left: 9.7, width: 80.5, height: 84 },
    camera: { style: "pro", top: 4, left: 6.4, width: 27.5, height: 22.2, radius: 31 }
  },
  "iphone-14": {
    label: "iPhone 14",
    frameRatio: 0.49,
    shellRadius: 26,
    safeZone: { top: 10.5, left: 10, width: 80, height: 84 },
    camera: { style: "dual", top: 4.6, left: 7.2, width: 23, height: 18.5, radius: 28 }
  },
  "iphone-14-plus": {
    label: "iPhone 14 Plus",
    frameRatio: 0.474,
    shellRadius: 28,
    safeZone: { top: 10.2, left: 9.8, width: 80.2, height: 84.2 },
    camera: { style: "dual", top: 4.4, left: 6.9, width: 24, height: 18.8, radius: 28 }
  },
  "iphone-14-pro": {
    label: "iPhone 14 Pro",
    frameRatio: 0.488,
    shellRadius: 27,
    safeZone: { top: 10.5, left: 9.9, width: 80.1, height: 83.9 },
    camera: { style: "pro", top: 4.2, left: 6.7, width: 26.4, height: 21.3, radius: 30 }
  },
  "iphone-14-pro-max": {
    label: "iPhone 14 Pro Max",
    frameRatio: 0.474,
    shellRadius: 28,
    safeZone: { top: 10.2, left: 9.6, width: 80.6, height: 84.1 },
    camera: { style: "pro", top: 4, left: 6.3, width: 27.6, height: 22.1, radius: 31 }
  },
  "iphone-15": {
    label: "iPhone 15",
    frameRatio: 0.488,
    shellRadius: 27,
    safeZone: { top: 10.6, left: 9.9, width: 80.2, height: 83.8 },
    camera: { style: "dual", top: 4.6, left: 7.1, width: 23.5, height: 18.8, radius: 29 }
  },
  "iphone-15-plus": {
    label: "iPhone 15 Plus",
    frameRatio: 0.474,
    shellRadius: 28,
    safeZone: { top: 10.2, left: 9.7, width: 80.4, height: 84.1 },
    camera: { style: "dual", top: 4.4, left: 6.8, width: 24, height: 19, radius: 29 }
  },
  "iphone-15-pro": {
    label: "iPhone 15 Pro",
    frameRatio: 0.486,
    shellRadius: 29,
    safeZone: { top: 10.4, left: 9.8, width: 80.4, height: 84 },
    camera: { style: "pro", top: 4.1, left: 6.6, width: 26.5, height: 21.5, radius: 32 }
  },
  "iphone-15-pro-max": {
    label: "iPhone 15 Pro Max",
    frameRatio: 0.472,
    shellRadius: 30,
    safeZone: { top: 10.1, left: 9.5, width: 80.8, height: 84.2 },
    camera: { style: "pro", top: 3.9, left: 6.1, width: 27.8, height: 22.4, radius: 33 }
  },
  "iphone-16": {
    label: "iPhone 16",
    frameRatio: 0.488,
    shellRadius: 27,
    safeZone: { top: 10.6, left: 9.9, width: 80.2, height: 83.8 },
    camera: { style: "dual-vertical", top: 4.4, left: 7.3, width: 19, height: 25.5, radius: 24 }
  },
  "iphone-16-plus": {
    label: "iPhone 16 Plus",
    frameRatio: 0.474,
    shellRadius: 29,
    safeZone: { top: 10.2, left: 9.7, width: 80.4, height: 84.1 },
    camera: { style: "dual-vertical", top: 4.2, left: 6.9, width: 19.6, height: 26, radius: 24 }
  },
  "iphone-16-pro": {
    label: "iPhone 16 Pro",
    frameRatio: 0.486,
    shellRadius: 29,
    safeZone: { top: 10.4, left: 9.8, width: 80.4, height: 84 },
    camera: { style: "pro", top: 4.1, left: 6.6, width: 26.8, height: 21.8, radius: 32 }
  },
  "iphone-16-pro-max": {
    label: "iPhone 16 Pro Max",
    frameRatio: 0.472,
    shellRadius: 30,
    safeZone: { top: 10.1, left: 9.5, width: 80.8, height: 84.2 },
    camera: { style: "pro", top: 3.9, left: 6.1, width: 28, height: 22.6, radius: 33 }
  }
};
